module.exports = __webpack_public_path__ + "static/media/menu3.215062f5.jpg";